import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { io } from 'socket.io-client';
import logo from '../assets/pasiicon.jpeg';
import construction from '../assets/construction.jpeg';






const slides = [
  {
    title: 'Faith-led spaces for lasting impact',
    description: 'A refined digital home for worship, service, stories, and modern community care.',
    cta: 'Explore ministries',
    to: '/ministries',
   image: "https://images.unsplash.com/photo-1493246507139-91e8fad9978e?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: 'Purposeful gatherings that welcome every season',
    description: 'Elegant digital programming that keeps every member connected and inspired.',
    cta: 'View sermons',
    to: '/sermons',
   image:"https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1600&q=80",
  },
  {
    title: 'Stories shaped by grace, service, and belonging',
    description: 'From sermons to leadership updates, everything is presented with clarity and care.',
    cta: 'Read stories',
    to: '/news',
  image:"https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=1600&q=80",
  },
];

const quickLinks = [
  {
    title: 'About our mission',
    text: 'Learn how Grace & Light serves people with clarity, warmth, and purposeful care.',
    image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=900&q=80',
    to: '/about',
  },
  {
    title: 'Ministries in action',
    text: 'See the programs that build community, encourage growth, and support every season.',
    image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=900&q=80',
    to: '/ministries',
  },
  {
    title: 'Sunday messages',
    text: 'Discover sermons that bring calm reflection, practical insight, and spiritual encouragement.',
    image: 'https://images.unsplash.com/photo-1509099836639-18ba1795216d?auto=format&fit=crop&w=900&q=80',
    to: '/sermons',
  },
  {
    title: 'Community updates',
    text: 'Stay connected with announcements, stories, and meaningful moments from the church family.',
    image: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=900&q=80',
    to: '/news',
  },
];

const values = [
  {
    title: 'Thoughtful gatherings',
    text: 'Every event is curated to feel welcoming, calm, and beautifully organized.',
  },
  {
    title: 'Personal support',
    text: 'Prayer care, guidance, and encouragement are shaped around real needs.',
  },
  {
    title: 'Clear communication',
    text: 'Sermons, stories, and updates are presented with elegance and ease.',
  },
];


const services = [
  {
    title: "Sunday First Service",
    time: "8:00 AM",
    location: "Main Sanctuary",
  },
  {
    title: "Sunday Second Service",
    time: "10:30 AM",
    location: "Main Sanctuary",
  },
  {
    title: "Midweek Fellowship",
    time: "Wednesday • 5:30 PM",
    location: "Church Auditorium",
  },
  {
    title: "Friday Kesha",
    time: "Last Friday • 9:00 PM",
    location: "Main Sanctuary",
  },
];




const API_BASE_URL = "https://church-backend-48tj.onrender.com";


function HomePage() {
  const [activeSlide, setActiveSlide] = useState(0);
const [expandedCulture, setExpandedCulture] = useState(null);
const [expandedSermon, setExpandedSermon] = useState(null);


  useEffect(() => {
    const timer = window.setInterval(() => {
      setActiveSlide((current) => (current + 1) % slides.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    document.querySelectorAll('.reveal').forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, []);

  const currentSlide = slides[activeSlide];




  //DOING CRUD

    const [events, setEvents] = React.useState([]);
  const [stories, setStories] = React.useState([]).slice(0, 5);
   const [ministries, setMinistries] = React.useState([]).slice(0, 4);
     const [sermons, setSermons] = useState([]);
       const [cultures,setCultures]=useState([]);


  
   useEffect(() => {
      // socket live adds
      const socket = io(API_BASE_URL, { transports: ['websocket'] });
      socket.on('connect', () => { /* connected */ });
      socket.on('getstory', (prod) => { if (prod) setStories(prev => [prod, ...prev]); });
       socket.on('getsermon', (prod) => { if (prod) setSermons(prev => [prod, ...prev]); });
         socket.on('getministry', (prod) => { if (prod) setMinistries(prev => [prod, ...prev]); });
           socket.on('getevent', (prod) => { if (prod) setEvents(prev => [prod, ...prev]); });
            socket.on('getculture', (prod) => { if (prod) setCultures(prev => [prod, ...prev]); });
              socket.on('updatestory', (prod) => { if (prod) setStories(prev => [prod, ...prev]); });
       socket.on('updatesermon', (prod) => { if (prod) setSermons(prev => [prod, ...prev]); });
         socket.on('updateministry', (prod) => { if (prod) setMinistries(prev => [prod, ...prev]); });
           socket.on('updateevent', (prod) => { if (prod) setEvents(prev => [prod, ...prev]); });
            socket.on('updateculture', (prod) => { if (prod) setCultures(prev => [prod, ...prev]); });
            
      socket.on('deleteculture', (id) => {
   setCultures(prev =>
      prev.filter(item => item._id !== id)
   );
});
socket.on('deletestory', (id) => {
   setStories(prev =>
      prev.filter(item => item._id !== id)
   );
});


socket.on('deletesermon', (id) => {
   setSermons(prev =>
      prev.filter(item => item._id !== id)
   );
});


socket.on('deleteministry', (id) => {
   setMinistries(prev =>
      prev.filter(item => item._id !== id)
   );
});


socket.on('deleteevent', (id) => {
   setEvents(prev =>
      prev.filter(item => item._id !== id)
   );
});

      return () => socket.disconnect();
    }, []);
  


    
    const getStories = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/stories`);
    
            if (!response.ok) {
                throw new Error("Failed to fetch stories");
            }
    
            const data = await response.json();
    
            setStories(data);
    
        } catch (err) {
            console.error(err);
        }
    };


      
   
     
      const getCultures = async () => {
          try {
              const response = await fetch(`${API_BASE_URL}/api/cultures`);
      
              if (!response.ok) {
                  throw new Error("Failed to fetch cultures");
              }
      
              const data = await response.json();
      
              setCultures(data);
      
          } catch (err) {
              console.error(err);
          }
      };

      
        const getMinistries = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/ministries`);
    
            if (!response.ok) {
                throw new Error("Failed to fetch ministries");
            }
    
            const data = await response.json();
    
            setMinistries(data);
    
        } catch (err) {
            console.error(err);
        }
    };

    
    
    
      const getEvents = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/events`);
    
            if (!response.ok) {
                throw new Error("Failed to fetch events");
            }
    
            const data = await response.json();
    
            setEvents(data);
    
        } catch (err) {
            console.error(err);
        }
    };
    




const getSermons = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/sermons`);

        if (!response.ok) {
            throw new Error("Failed to fetch sermons");
        }

        const data = await response.json();

        setSermons(data);

    } catch (err) {
        console.error(err);
    }
};

    
    
    
    
    useEffect(() => {
        getStories();
        getMinistries();
getEvents();
getSermons();
getCultures();
    }, []);


    const storyClasses = [
  "story-one",
  "story-two",
  "story-three",
  "story-four",
  "story-five",
    ];




  return (
    <div className="page-shell">
      <section className="hero-banner" style={{ backgroundImage: `url(${currentSlide.image})` }}>
        <div className="hero-overlay" />
        <div className="hero-content padleft">
          <p className="eyebrow">2026 ministry experience</p>
          <h1>{currentSlide.title}</h1>
          <p>{currentSlide.description}</p>
          <div className="hero-actions">
            <Link className="button button--primary" to={currentSlide.to}>{currentSlide.cta}</Link>
            <Link className="button button--secondary" to="/contact">Plan a visit</Link>
          </div>
          <div className="hero-dots" aria-label="Homepage hero slider">
            {/*slides.map((slide, index) => (
              <button
                key={slide.title}
                className={`hero-dot ${index === activeSlide ? 'is-active' : ''}`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))*/}
          </div>
        </div>
      </section>



      {/*================ WELCOME SECTION ================*/}

<section className="welcome-home-section">

<div className="container">

<div className="welcome-home-grid">

<div className="welcome-home-content">

<span>

WELCOME HOME

</span>

<h2>

We're Glad
You're Here.

</h2>

<p>

Whether you're discovering faith for the first time,
looking for a church family, or simply visiting us today,
know that you are warmly welcomed. We believe every
person has a place to belong, grow in Christ and experience
God's love.

</p>

<p>

Join us as we worship together, build lasting relationships
and impact our community through the transforming power
of Jesus Christ.

</p>

</div>

<div className="welcome-home-card">

    <div className="welcome-pastor-image">

        <img
            src={logo}
          
        />

        <div className="welcome-pastor-details">

        <h3>

            Rev. Gideon & Gladys Muuo

        </h3>

        <p>

            Senior Pastors

        </p>

    </div>

    </div>

    

</div>

</div>

</div>

</section>


      <section className="section">
        <div className="section-heading">
          <p className="eyebrow">A modern ministry home</p>
          <h2>Elegant experiences for worship, stories, and connection.</h2>
          <p className="section-copy">The homepage now opens with rich imagery, thoughtful copy, and a premium layout that feels built for 2026.</p>
        </div>

        <div className="card-grid">
          {cultures.slice(0,4).map((item) => (
            <Link className="feature-link-card" key={item._id}>
              <img src={item.image} alt={item.title} className="card-image" />
              <div className="card-body">
                <h3>{item.title}</h3>
               <p
  className={
    expandedCulture === item._id
      ? "story-text expanded"
      : "story-text"
  }
>
  {item.text}
</p>

{item.text && item.text.length > 100 && (
  <button
    className="read-more-btn"
    onClick={(e) => {
      e.preventDefault();
      setExpandedCulture(
        expandedCulture === item._id ? null : item._id
      );
    }}
  >
    {expandedCulture === item._id
      ? "Show Less"
      : "Read More"}
  </button>
)}
              </div>
            </Link>
          ))}
        </div>
      </section>






{/*

      <section className="discover-section">

    <div className="discover-title">

        <span>DISCOVER YOUR PLACE</span>

        <h2>

            Everyone Belongs.
            <br />
            Every Gift Matters.

        </h2>

        <p>

            Whether you're joining us for the first time
            or looking for a place to serve,
            there is a ministry waiting for you.

        </p>

    </div>

    <div className="discover-layout">

        <div className="discover-center">

            <img
                src="https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=1200&q=80"
                alt="Church Family"
            />

        </div>

        {ministries.map((item) => (

            <Link
                key={item.id}
                to={"/ministries"}
                className="ministry-circle"
            >

                <img
                    src={item.image}
                    alt={item.title}
                />

                <h4>{item.title}</h4>

            </Link>

        ))}

    </div>

</section>

*/}



<section className="construction-preview">

    <div className="construction-glow construction-glow-one"></div>
    <div className="construction-glow construction-glow-two"></div>

    <div className="container construction-wrapper">

        <div className="construction-content">

            <span className="construction-tag">

                BUILDING PROJECT

            </span>

            <h2>

                Building A Home
                <br />
                For Worship,
                <span> Hope & Generations.</span>

            </h2>

            <p>

                We are trusting God as we build a beautiful place
                where lives will continue to be transformed through
                worship, prayer and God's Word.

            </p>

            <div className="construction-actions">

                <Link
                    to="/construction"
                    className="construction-btn"
                >

                    View Construction Project

                </Link>

            </div>

        </div>



        <div className="construction-right">

            <div className="construction-image">

                <img
                    src={construction}
                    alt="Church Construction"
                />

                <div className="construction-progress">

                    <small>Construction Progress</small>

                    <h3>20%</h3>

                    <div className="progress-bar">

                        <span></span>

                    </div>

                </div>

            </div>



            <div className="payment-card">

                <div className="payment-top">

                    <div>

                        <small>M-PESA</small>

                        <h3>Support The Project</h3>

                    </div>

                    <div className="payment-icon">

                        ❤

                    </div>

                </div>

                <div className="payment-body">

                    <div className="pay-item">

                        <span>Paybill Number</span>

                        <h2>400222</h2>

                    </div>

                    <div className="pay-item">

                        <span>Account</span>

                        <h2>1865849#</h2>

                    </div>

                </div>

            </div>

        </div>

    </div>

</section>




<section className="home-sermons-preview">

    <div className="container">

        <div className="sermons-preview-header">

            <div>

                <span>RECENT SERMONS</span>

                <h2>
                    Be Encouraged By
                    <br />
                    God's Word
                </h2>

                <p>

                    Catch up on the latest messages that inspire faith,
                    strengthen hope and encourage everyday Christian living.

                </p>

            </div>

            <Link
                to="/sermons"
                className="sermons-preview-btn"
            >

                View All Sermons

            </Link>

        </div>

        <div className="sermons-preview-grid">

            {sermons.slice(0,1).map((item,index)=>(

                 <Link
                to="/sermons"
                    key={item._id || index}
                    className="sermon-preview-card"
                >

                    <div className="sermon-preview-image">

                        <img
                            src={item.image}
                            alt={item.title}
                        />

                    </div>

                    <div className="sermon-preview-content">

                        <span>

                            {item.readingTime}

                        </span>

                        <h3>

                            {item.title}

                        </h3>

                       <p
  className={
    expandedSermon === item._id
      ? "story-text expanded"
      : "story-text"
  }
>
  {item.introduction}
</p>

{item.introduction.length > 100 && (
  <button
    className="read-more-btn"
    onClick={(e) => {
      e.preventDefault();
      setExpandedSermon(
        expandedSermon === item._id ? null : item._id
      );
    }}
  >
    {expandedSermon === item._id
      ? "Show Less"
      : "Read More"}
  </button>
)}

                        

                    </div>

                </Link>

            ))}

        </div>

    </div>

</section>



<section className="home-timeline-preview">

<div className="container">

<div className="preview-heading">

<span>UPCOMING EVENTS</span>

<h2>
A Glimpse Of What's Coming
</h2>

<p>

Worship services, fellowships and church gatherings
happening over the next few days.

</p>

</div>


<div className="preview-timeline">

{events.slice(0,1).map((item,index)=>(

<div
className="preview-item"
key={item._id || index}
>

<div className="preview-date">

 {new Date(item.date).toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  })}

</div>

<div className="preview-dot"></div>

<div className="preview-content">

<h3>{item.title}</h3>

<p>{item.description}</p>

<span>{item.time}</span>

</div>

</div>

))}

</div>

<div className="preview-footer">

<Link
to="/news"
className="preview-btn"
>

Explore All Events

</Link>

</div>

</div>

</section>


<section className="stories-section">

    <div className="stories-heading">

        <span>CHURCH LIFE</span>

        <h2>

            Every Week,
            <br />
            God Is Writing New Stories.

        </h2>


        <p>

            Every worship service, prayer meeting, outreach,
            youth gathering and fellowship becomes another
            chapter of God's faithfulness.

        </p>

    </div>

    <div className="stories-gallery">
     {stories.map((prod, index) => (
  <img
    key={prod._id || index}
    className={storyClasses[index]}
    src={prod.image}
  />
))}


    </div>

</section>




  


    </div>
  );
}

export default HomePage;
